module.exports = __webpack_public_path__ + "0ae04eef2bedcc18c4976d9b59e17dc6.jpg";